import React, { Fragment } from "react";
import PublicPage from "../../../containers/PublicPage/index";
import LoginForm from "./form";
import { Consumer } from "../../../containers/Context";
import { getMessage } from "../../../lib/translator";
import { ZOPPING_URL } from "../../../config/app";

export default class Login extends React.Component {
  handleSignUpRedirection = () => {
    window.location.href = `${ZOPPING_URL}?sign-up=true`;
  };

  render() {
    return (
      <PublicPage className="login">
        <Consumer>
          {(isEnterprise) => (
            <Fragment>
              <header className="header">
                <h1 className="heading">{getMessage("login.heading")}</h1>
                <h2 className="subheading">{getMessage("login.subheading")}</h2>
              </header>
              <div className="box">
                <LoginForm enterprise={isEnterprise} />
                {!isEnterprise && (
                  <p className="alt-action">
                    {getMessage("login.newUser.message")}{" "}
                    <span
                      onClick={this.handleSignUpRedirection}
                      className="sign-up-redirection"
                    >
                      {getMessage("login.newUser.signupText")}
                    </span>
                    <br />
                    <br />
                    <div>
                      {getMessage("account.creation.happens.on.zopping")}
                    </div>
                  </p>
                )}
              </div>
            </Fragment>
          )}
        </Consumer>
      </PublicPage>
    );
  }
}
